var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_1240",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_1240)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0007 16.2728C28.0007 15.4219 27.9227 14.6037 27.778 13.8182H16.2461V18.4601H22.8358C22.5519 19.9601 21.6893 21.231 20.3925 22.0819V25.0928H24.3496C26.6649 23.0037 28.0007 19.9273 28.0007 16.2728Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2428 28C19.5487 28 22.3204 26.9255 24.3463 25.0928L20.3892 22.0819C19.2927 22.8019 17.8902 23.2273 16.2428 23.2273C13.0537 23.2273 10.3544 21.1164 9.39151 18.28H5.30078V21.3891C7.31553 25.3109 11.4563 28 16.2428 28Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39308 18.2801C9.14819 17.5601 9.00905 16.791 9.00905 16.0001C9.00905 15.2091 9.14819 14.4401 9.39308 13.7201V10.611H5.30235C4.47308 12.231 4 14.0637 4 16.0001C4 17.9364 4.47308 19.7691 5.30235 21.3892L9.39308 18.2801Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2428 8.77273C18.0405 8.77273 19.6545 9.37819 20.9235 10.5673L24.4354 7.12546C22.3149 5.18909 19.5432 4 16.2428 4C11.4563 4 7.31553 6.68909 5.30078 10.6109L9.39151 13.72C10.3544 10.8836 13.0537 8.77273 16.2428 8.77273Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.173ff24fd34fcd6df4166e28f4b8a334.svg";
export { ForwardRef as ReactComponent };